'use strict';
var ImagePosition;
(function (ImagePosition) {
    ImagePosition["Top"] = "top";
    ImagePosition["Left"] = "left";
    ImagePosition["Right"] = "right";
})(ImagePosition || (ImagePosition = {}));
export default ImagePosition;
